import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxHeight: "80vh",
  },
  headContainer: {
    backgroundColor: "#0154b0",
    minWidth: "40rem",
  },
  main: {
    borderRadius: "4px",
  },
  inputRoot: {
    margin: "1rem",
  },
  inputInput: {
    borderRadius: "4px",
    backgroundColor: "white",
    border: "solid white 1px",
    "&:hover": {
      border: "solid lightgray 1px",
    },
    transition: theme.transitions.create("width"),
    width: "34.5rem",
    padding: "0.5rem",
  },
  matchingRequestContainer: {
    borderRadius: "4px",
  },
  searchIcon: {
    color: "white",
  },
  loader: {
    minHeight: "19rem",
    display: "flex",
    alignItems: "center",
  },
}));

export default useStyles;
